export const PAGE_INFO = {
  INITIAL_PAGE: 1,
  LIMIT_PER_PAGE: 10,
};
